import cx from 'classnames'
import { ConvertableCommentTodoForm } from 'components/ConvertableCommentTodoForm/ConvertableCommentTodoForm'
import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import { ArticleView, UserRole } from 'types'
import Styles from './NewCollabItemForm.module.scss'
import { NewCollabItemFormProps } from './Types'
import { useCanViewAs } from 'components/Can'
import { useCurrentArticleId } from 'hooks/useCurrentArticleId'
import { useArticleMeta } from 'hooks/useArticleMeta'

/**
 * Form to create a new comment or task. Wrap this component to provide styles
 * or additional interactions.
 */
const NewCollabItemForm = observer((props: NewCollabItemFormProps) => {
  const docStore = useDocStore()
  const currentArticleId = useCurrentArticleId()
  const article = useArticleMeta(currentArticleId)
  const canViewAs = useCanViewAs(article?.almanac_file.workspace.id || null)

  const canConvertToTodo =
    docStore.isMainLayer &&
    docStore.articleView === ArticleView.Editing &&
    canViewAs([UserRole.GUEST, UserRole.MEMBER, UserRole.ADMIN, UserRole.SUPER_ADMIN])

  let placeholder: string
  if (canConvertToTodo) {
    placeholder = docStore.filters.activeKeys.has('todos') ? 'Create a task...' : 'Create a comment or task...'
  } else {
    placeholder = 'Create a comment...'
  }

  const styles = {
    commentFormWrapper: cx({ [Styles.active]: props.active }),
    commentForm: Styles.commentForm,
    commentInputContainer: Styles.inputContainer,
    commentInput: Styles.input,
    todoFormWrapper: Styles.todoWrapper,
    todoForm: Styles.todoForm,
  }

  return (
    <ConvertableCommentTodoForm
      hideActionsOnEmpty
      docStore={docStore}
      placeholder={placeholder}
      styles={styles}
      autoConvertToTodo={docStore.filters.activeKeys.has('todos')}
      {...props}
    />
  )
})

export { NewCollabItemForm }
